export default __webpack_public_path__ + "static/media/pangolin.6a134905.svg";